import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import PinRoundedIcon from '@mui/icons-material/PinRounded';
import { routes } from '../../common/utils/routes';

export const optionsAccountMenu = [
  {
    iconOutlined: LockOutlinedIcon,
    iconFilled: LockRoundedIcon,
    title: 'Đổi mật khẩu',
    link: routes.CHANGE_PASSWORD,
  },
  {
    iconOutlined: PinOutlinedIcon,
    iconFilled: PinRoundedIcon,
    title: 'Đổi mã PIN',
    link: routes.CHANGE_PIN_CODE,
    divider: true,
    navigator: true,
  },
  {
    iconOutlined: ExitToAppIcon,
    iconFilled: ExitToAppIcon,
    title: 'Đăng xuất',
    link: routes.SIGN_OUT,
  },
];
